/******************************************************************************
 * FeatureFlagListItem: table row for a feature flag with an on/off toggle.
 * Flags are read-only otherwise (developer-owned keys); the only admin action is
 * flipping `active`.
 *****************************************************************************/

/* Imports */
import { Typography } from "@material-tailwind/react";
import Switch from "../../switch/Switch";
/***/

/**
* FeatureFlagListItem: display a feature flag row
* @param flag - feature flag data
* @param onToggle - toggle callback (new active value)
* @param disabled - disable the toggle (e.g. while a request is in flight)
* @param isLast - is last item
*/
export default function FeatureFlagListItem({
  flag,
  onToggle,
  disabled = false,
  isLast = false
}: {
  flag: EasyTech.FeatureFlag,
  onToggle: (active: boolean) => void,
  disabled?: boolean,
  isLast?: boolean
}) {
  return (
    <tr className={`page-list-item ${isLast && "last"}`}>
      <td>
        <div className="flex gap-2 items-center">
          <Typography>{flag.description || flag.code}</Typography>
        </div>
      </td>

      <td>
        <div className="flex gap-2 items-center">
          <Typography className="text-xs text-gray-500">{flag.code}</Typography>
        </div>
      </td>

      <td>
        <div className="flex gap-2 items-center">
          <Switch checked={flag.active} disabled={disabled} onChange={(v) => onToggle(v)} />
        </div>
      </td>
    </tr>
  );
}
/***/
